module.exports = __webpack_public_path__ + "static/three_explain_en.c2a0d6eb.png";